// extracted by mini-css-extract-plugin
export default {"title":"style_title__orTym","closeBtn":"style_closeBtn__Ga3+2"};